import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const FIREBASE_TOKEN_TIME_KEY = 'firebaseTokenTime'

function saveFirebaseTokenTimeToLocalStorage(prefix) {
  window.localStorage.setItem(`${prefix}${FIREBASE_TOKEN_TIME_KEY}`, new Date().toISOString())
}

function shouldSaveFirebaseToken(prefix, hoursThreshold = 24) {
  const storedTime = window.localStorage.getItem(`${prefix}${FIREBASE_TOKEN_TIME_KEY}`)

  if (!storedTime) {
    return true
  }

  const currentTime = new Date().toISOString()
  const storedTimeMillis = new Date(storedTime).getTime()
  const thresholdMillis = 1000 * 60 * 60 * hoursThreshold

  return currentTime - storedTimeMillis > thresholdMillis
}

export default function createFirebaseManager({ appConfig, vapidKey }) {
  const app = initializeApp(appConfig)
  const messaging = getMessaging(app)

  return {
    app,
    messaging,
    getToken: async () => {
      let registration = undefined
      if (import.meta.env.MODE === 'development') {
        registration = await navigator.serviceWorker.register('src/libraries/firebase/firebase-messaging-sw.js')
      }
      return getToken(messaging, { vapidKey, serviceWorkerRegistration: registration })
    },
    onMessage: nextObserver => {
      return onMessage(messaging, nextObserver)
    },
    saveFirebaseTokenTimeToLocalStorage,
    shouldSaveFirebaseToken
  }
}
